/*
 * Copyright (c)  CYBERKOALA LLC 2025.
 * Proprietary License.
 * Redistribution and use in source and binary forms, with or without
 * modification, are restricted.
 */

import { createContext } from 'react';

interface AudioContextValue {
  isSpeaking: boolean;
  setIsSpeaking: (value: boolean) => void;
  volumeLevel: number;
  setVolumeLevel: (volume: number) => void;
  deviceId?: string; // microphone
  setDeviceId: (deviceId: string) => void;
}

export const GlobalAudioContext = createContext<AudioContextValue>({
  isSpeaking: false,
  setIsSpeaking: () => {},
  volumeLevel: 0,
  setVolumeLevel: () => {},
  deviceId: '',
  setDeviceId: () => {},
});
